import { useContext } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchSegments } from 'api/segments';
import { FilterProviderContext } from 'components/filter/filters-next/FilterProvider';
import { useFiltersByKey } from 'components/filter/filters-next/useFiltersByKey';
import { ModelType } from 'components/filter/types-legacy';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { segmentQueryKeys } from 'queries/segment-query-keys';

const useCurrentSegment = () => {
    const { accountId } = useCurrentAccount();
    const { resource, cacheKey } = useContext(FilterProviderContext);
    const { segmentId: isViewingSegmentId } = useFiltersByKey(cacheKey);
    const { data: savedSegments } = useSuspenseQuery({
        queryKey: segmentQueryKeys.all(accountId, resource as ModelType),
        queryFn: () => fetchSegments(accountId, resource as ModelType),
    });

    return savedSegments.find(s => s.id === isViewingSegmentId);
};

export { useCurrentSegment };
